export const MOCK_CLIENT_ID = '00000000';
